import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import extractText from 'flarum/common/utils/extractText';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
const translationPrefix = 'yippy-auth-ldap.forum.';
const translationErrorsPrefix = 'yippy-auth-ldap.forum.errors.';
export default class LDAPLogInModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);

    /**
     * The value of the identification input.
     *
     * @type {Function}
     */
    this.identification = Stream(this.attrs.identification || '');

    /**
     * The value of the password input.
     *
     * @type {Function}
     */
    this.password = Stream(this.attrs.password || '');

    /**
     * The value of the remember me input.
     *
     * @type {Function}
     */
    this.remember = Stream(!!this.attrs.remember);
  }
  className() {
    return 'LogInModal Modal--small';
  }
  title() {
    return app.translator.trans(translationPrefix + 'log_in_with', {
      server: app.forum.attribute('yippy-auth-ldap.method_name')
    });
  }
  content() {
    return [m("div", {
      className: "Modal-body"
    }, this.body()), m("div", {
      className: "Modal-footer"
    }, this.footer())];
  }
  body() {
    return [
    //<LogInButtons/>,

    m("div", {
      className: "Form Form--centered"
    }, this.fields().toArray())];
  }
  fields() {
    const items = new ItemList();
    const idLabel = app.translator.trans('core.forum.log_in.username_or_email_placeholder');
    const passwordLabel = app.translator.trans('core.forum.log_in.password_placeholder');
    items.add('identification', m("div", {
      className: "Form-group"
    }, idLabel, m("input", {
      className: "FormControl",
      name: "identification",
      type: "text",
      placeholder: idLabel,
      bidi: this.identification,
      disabled: this.attrs.loading
    })), 30);
    items.add('password', m("div", {
      className: "Form-group"
    }, passwordLabel, m("input", {
      className: "FormControl",
      name: "password",
      type: "password",
      placeholder: passwordLabel,
      bidi: this.password,
      disabled: this.attrs.loading
    })), 20);

    /*items.add('remember', <div className="Form-group">
      <div>
        <label className="checkbox">
          <input type="checkbox" bidi={this.remember} disabled={this.loading} />
          {app.translator.trans('core.forum.log_in.remember_me_label')}
        </label>
      </div>
    </div>, 10);*/

    items.add('submit', m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      name: 'submit_log_in',
      type: 'submit',
      loading: this.attrs.loading
    }, app.translator.trans('core.forum.log_in.submit_button'))), -10);
    return items;
  }
  footer() {
    return [
      /*<p className="LogInModal-forgotPassword">
        <a onclick={this.forgotPassword.bind(this)}>{app.translator.trans('core.forum.log_in.forgot_password_link')}</a>
      </p>,
        app.forum.attribute('allowSignUp') ? (
        <p className="LogInModal-signUp">
          {app.translator.trans('core.forum.log_in.sign_up_text', {a: <a onclick={this.signUp.bind(this)}/>})}
        </p>
      ) : ''*/
    ];
  }
  onready() {
    this.$('[name=' + (this.identification() ? 'password' : 'identification') + ']').select();
  }

  /**
   * Attempt to log in a user to LDAP
   */
  login(body, options) {
    if (options === void 0) {
      options = {};
    }
    return app.request(_objectSpread({
      method: 'POST',
      url: app.forum.attribute('baseUrl') + '/auth/ldap',
      body
    }, options));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    $('input[name="identification"]').prop("disabled", true);
    $('input[name="password"]').prop("disabled", true);
    $('button[name="submit_log_in"]').prop("disabled", true);
    const identification = this.identification();
    const password = this.password();
    const remember = this.remember();
    const csrfToken = app.session.csrfToken;
    const data = {
      identification,
      password,
      remember,
      csrfToken
    };
    const options = {
      errorHandler: this.onerror.bind(this),
      modifyText: this.modifyResponse.bind(this)
    };
    this.login(data, options).catch(() => {});
  }

  /*
   * To ensure the request on complete will re-enable elements on the login popup or enable the sign up modal depending on the response condition.
   */
  modifyResponse(response) {
    $('input[name="identification"]').prop("disabled", false);
    $('input[name="password"]').prop("disabled", false);
    $('button[name="submit_log_in"]').prop("disabled", false);
    if (response.indexOf('app.authenticationComplete') >= 0) {
      response.replace(/(^.*\{|\}.*$)/g, '');
      var matches = response.match(/[^{\}]+(?=})/g);
      if (matches.length > 0) {
        app.authenticationComplete(JSON.parse("{" + matches[0] + "}"));
      }
    } else if (response.indexOf(app.translator.trans(translationErrorsPrefix + 'core_csrf_token_mismatch')) >= 0) {
      // Identify the default csrf_token_mismatch response that is sent in html. Oddly this does not prompt onerror method, will manually invoke onerror method.
      this.onerror({
        alert: {
          content: app.translator.trans(translationErrorsPrefix + 'csrf_token_mismatch'),
          controls: false,
          dismissible: false,
          type: "error"
        },
        status: 400,
        response: {
          errors: [{
            code: 'csrf_token_mismatch',
            status: 400
          }]
        }
      });
    }
    this.loaded();
    return response;
  }
  onerror(error) {
    var code_error = null;
    if (error.response.errors && error.response.errors.length > 0) {
      code_error = error.response.errors[0].code;
    }
    if (error.status === 401) {
      switch (code_error) {
        case 'search_filter_is_invalid':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'not_authenticated':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'account.invalid_inputs':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error);
          break;
        case 'account.not_found':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'account.incorrect_details':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error);
          break;
        case 'account.password_expired':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error);
          break;
        case 'account.disabled':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'account.expired':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'account.locked':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name')
          });
          break;
        case 'domains.no_domains':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error);
          break;
        case 'domains.empty_host':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.empty_base_dn':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.empty_user_username':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name'),
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.empty_search_field':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name'),
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.username_field_does_not_exist':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name'),
            data: error.response.errors[0].data,
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.mail_field_does_not_exist':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name'),
            data: error.response.errors[0].data,
            domain_index: error.response.errors[0].domain_index
          });
          break;
        case 'domains.connection_failed':
          error.alert.content = app.translator.trans(translationErrorsPrefix + code_error, {
            server: app.forum.attribute('yippy-auth-ldap.method_name'),
            data: error.response.errors[0].data,
            domain_index: error.response.errors[0].domain_index
          });
          break;
        default:
      }
    }
    super.onerror(error);
  }
}
flarum.reg.add('yippy-auth-ldap', 'forum/components/LDAPLogInModal', LDAPLogInModal);